import React, { useState } from 'react';

const Formulario = () => {
  const [enviado, setEnviado] = useState(false);
  const [cargando, setCargando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCargando(true);

    // 1. PEGA AQUÍ TU URL DE GOOGLE (la que copiaste de la imagen)
    const URL_GOOGLE = 'https://script.google.com/macros/s/AKfycbxDQl0vP5BH-_GbdK2JjppgrqNcwG3nOY5zBCm1Obo-Mypy3cwSbPmAY9O0wYC5EtzEuw/exec'; 

    const formData = new FormData(e.target);
    const data = {
      nombre: formData.get('nombre'),
      telefono: formData.get('telefono'),
      correo: formData.get('correo'),
      cuentaConPlan: formData.get('cuentaConPlan'),
      ciudad: formData.get('ciudad'),
      cp: formData.get('cp'),
      estado: formData.get('estado'),
      mensaje: formData.get('mensaje'),
    };

    try {
      await fetch(URL_GOOGLE, {
        method: 'POST',
        mode: 'no-cors', // Requerido para Google Scripts
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
      
      setEnviado(true);
    } catch (error) {
      console.error("Error:", error);
      alert("Hubo un error al enviar. Por favor intenta de nuevo.");
    } finally {
      setCargando(false);
    }
  };

  if (enviado) {
    return (
      <div className="max-w-4xl mx-auto bg-zinc-900/80 p-16 rounded-3xl border-2 border-yellow-400 text-center animate-in fade-in zoom-in duration-500">
        <div className="text-6xl mb-4">✅</div>
        <h2 className="text-3xl font-black text-white uppercase">¡Mensaje Recibido!</h2>
        <p className="text-yellow-400 mt-4 text-lg">
          Tus datos se han guardado en nuestro sistema. <br/>
          Un asesor de <strong>PABS</strong> te contactará muy pronto.
        </p>
        <button 
          onClick={() => setEnviado(false)}
          className="mt-8 text-zinc-500 uppercase text-xs hover:text-white transition-colors"
        >
          Enviar otro mensaje
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto bg-zinc-900/80 backdrop-blur-md p-10 rounded-3xl border border-zinc-800 shadow-2xl text-white">
      <div className="text-center mb-10">
        <p className="text-yellow-400 italic font-semibold tracking-widest uppercase text-xs mb-2">¡Contáctanos!</p>
        <h2 className="text-4xl font-black text-white uppercase tracking-tighter">Envíanos un mensaje</h2>
        <div className="h-1 w-20 bg-yellow-400 mx-auto mt-4 rounded-full"></div>
      </div>
      
      <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="md:col-span-2">
          <label className="text-xs font-bold uppercase text-gray-400 ml-1">Nombre Completo *</label>
          <input 
            name="nombre"
            type="text" 
            className="w-full bg-zinc-800 border border-zinc-700 p-3 rounded-xl mt-1 focus:border-yellow-400 focus:ring-1 focus:ring-yellow-400 outline-none transition-all text-white" 
            placeholder="Ej. Juan Pérez"
            required 
          />
        </div>
        
        <div>
          <label className="text-xs font-bold uppercase text-gray-400 ml-1">Teléfono de Contacto *</label>
          <input 
            name="telefono"
            type="tel" 
            className="w-full bg-zinc-800 border border-zinc-700 p-3 rounded-xl mt-1 focus:border-yellow-400 outline-none transition-all text-white" 
            placeholder="10 dígitos"
            required 
          />
        </div>
        
        <div>
          <label className="text-xs font-bold uppercase text-gray-400 ml-1">Correo Electrónico</label>
          <input 
            name="correo"
            type="email" 
            className="w-full bg-zinc-800 border border-zinc-700 p-3 rounded-xl mt-1 focus:border-yellow-400 outline-none transition-all text-white" 
            placeholder="tu@correo.com"
          />
        </div>

        <div>
          <label className="text-xs font-bold uppercase text-gray-400 ml-1">¿Cuentas con Plan PABS? *</label>
          <select name="cuentaConPlan" className="w-full bg-zinc-800 border border-zinc-700 p-3 rounded-xl mt-1 focus:border-yellow-400 outline-none transition-all text-white appearance-none">
            <option value="No especificado">Elige una opción</option>
            <option value="Si">Sí, ya soy cliente</option>
            <option value="No">No, busco información</option>
          </select>
        </div>

        <div>
          <label className="text-xs font-bold uppercase text-gray-400 ml-1">Ciudad *</label>
          <input 
            name="ciudad"
            type="text" 
            className="w-full bg-zinc-800 border border-zinc-700 p-3 rounded-xl mt-1 focus:border-yellow-400 outline-none transition-all text-white" 
            required 
          />
        </div>

        <div>
          <label className="text-xs font-bold uppercase text-gray-400 ml-1">Código Postal</label>
          <input 
            name="cp"
            type="text" 
            className="w-full bg-zinc-800 border border-zinc-700 p-3 rounded-xl mt-1 focus:border-yellow-400 outline-none transition-all text-white" 
          />
        </div>

        <div>
          <label className="text-xs font-bold uppercase text-gray-400 ml-1">Estado *</label>
          <input 
            name="estado"
            type="text" 
            className="w-full bg-zinc-800 border border-zinc-700 p-3 rounded-xl mt-1 focus:border-yellow-400 outline-none transition-all text-white" 
            required 
          />
        </div>

        <div className="md:col-span-2">
          <label className="text-xs font-bold uppercase text-gray-400 ml-1">Mensaje o Dudas *</label>
          <textarea 
            name="mensaje"
            className="w-full bg-zinc-800 border border-zinc-700 p-3 rounded-xl mt-1 h-32 focus:border-yellow-400 outline-none transition-all text-white" 
            placeholder="Cuéntanos cómo podemos ayudarte..."
            required
          ></textarea>
        </div>

        <div className="md:col-span-2 mt-4">
          <button 
            type="submit"
            disabled={cargando}
            className={`w-full ${cargando ? 'bg-zinc-700' : 'bg-yellow-400 hover:bg-yellow-500'} text-black font-black py-4 rounded-xl uppercase transition-all transform hover:scale-[1.02] shadow-xl shadow-yellow-400/10`}
          >
            {cargando ? 'Enviando...' : 'Enviar Información'}
          </button>
          <p className="text-center text-[10px] text-gray-500 mt-4 uppercase tracking-widest">
            Tus datos están protegidos por nuestro aviso de privacidad
          </p>
        </div>
      </form>
    </div>
  );
};

export default Formulario;